import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

interface Props extends ChildProps {
  isOpening?: boolean
  disabled?: boolean
}
const AreaContent = ({ children, isOpening, disabled }: Props) => {
  return (
    <div
      className={clsx(
        'flex w-full flex-col gap-4 px-6 py-4',
        isOpening !== undefined && 'accordion',
        isOpening !== undefined && (isOpening === true ? 'opening' : 'p-0!'),
        disabled && 'pointer-events-none opacity-40'
      )}
    >
      {children}
    </div>
  )
}

export default AreaContent
